/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetSiteMiscSettingResponseData,
  GetSiteMiscSettingResponseDataFromJSON,
  GetSiteMiscSettingResponseDataFromJSONTyped,
  GetSiteMiscSettingResponseDataToJSON
} from './GetSiteMiscSettingResponseData'

/**
 *
 * @export
 * @interface UpdateSiteMiscSettingOGPFileResponse
 */
export interface UpdateSiteMiscSettingOGPFileResponse {
  /**
   *
   * @type {number}
   * @memberof UpdateSiteMiscSettingOGPFileResponse
   */
  status?: number
  /**
   *
   * @type {GetSiteMiscSettingResponseData}
   * @memberof UpdateSiteMiscSettingOGPFileResponse
   */
  data?: GetSiteMiscSettingResponseData
}

export function UpdateSiteMiscSettingOGPFileResponseFromJSON(json: any): UpdateSiteMiscSettingOGPFileResponse {
  return UpdateSiteMiscSettingOGPFileResponseFromJSONTyped(json, false)
}

export function UpdateSiteMiscSettingOGPFileResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateSiteMiscSettingOGPFileResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetSiteMiscSettingResponseDataFromJSON(json['data'])
  }
}

export function UpdateSiteMiscSettingOGPFileResponseToJSON(value?: UpdateSiteMiscSettingOGPFileResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetSiteMiscSettingResponseDataToJSON(value.data)
  }
}
